export enum StorageKey {
  ACCESS_TOKEN = 'access_token',
  REFRESH_TOKEN = 'refresh_token',
  ID_TOKEN = 'id_token',
  EXPIRY_DATE = 'expiry_date',
  TOKEN = 'token',
  USERNAME = 'username',
  CONFIG = 'config',
  SHOULD_REMEMBER_ME = 'should_remember_me',
  TABLE_CONFIG = 'table_config',
  PKCE_VERIFIER = 'pkce_verifier',
  OAUTH_STATE = 'oauth_state',
}
